/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteContextResourceClientTerms
 */
export interface QuoteContextResourceClientTerms {
    /**
     * 
     * @type {string}
     * @memberof QuoteContextResourceClientTerms
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteContextResourceClientTerms
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteContextResourceClientTerms
     */
    fileName: string;
    /**
     * 
     * @type {boolean}
     * @memberof QuoteContextResourceClientTerms
     */
    isAgencyTerms?: boolean;
}

/**
 * Check if a given object implements the QuoteContextResourceClientTerms interface.
 */
export function instanceOfQuoteContextResourceClientTerms(value: object): value is QuoteContextResourceClientTerms {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    return true;
}

export function QuoteContextResourceClientTermsFromJSON(json: any): QuoteContextResourceClientTerms {
    return QuoteContextResourceClientTermsFromJSONTyped(json, false);
}

export function QuoteContextResourceClientTermsFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteContextResourceClientTerms {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
        'fileName': json['fileName'],
        'isAgencyTerms': json['isAgencyTerms'] == null ? undefined : json['isAgencyTerms'],
    };
}

export function QuoteContextResourceClientTermsToJSON(value?: QuoteContextResourceClientTerms | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'url': value['url'],
        'fileName': value['fileName'],
        'isAgencyTerms': value['isAgencyTerms'],
    };
}

